import { useState } from "react"
import styles from "./survey.module.scss"

interface Props {
  selectSurveryOption: (option: string) => void
  moveNextView: (view: string) => void
  onOtherTextChange: (text: string) => void
  surveyOption: string
  tierName: string
}

const Survey = ({ selectSurveryOption, moveNextView, onOtherTextChange, surveyOption }: Props) => {
  const [otherText, setOtherText] = useState("")

  const options = {
    plans_too_pricy: "Cost",
    not_using: "Not using",
    another_solution: "Found alternate solution",
    customer_support: "Technical issues",
    wrong_plan: "Wrong plan",
    other: "Other",
  }

  const handleOtherTextChange = (value: string) => {
    setOtherText(value)
    onOtherTextChange(value)
  }

  const onContinueClick = () => {
    switch (surveyOption) {
      case "customer_support":
        moveNextView("customer_support")
        break
      case "wrong_plan":
        moveNextView("switch_your_plan")
        break
      case "plans_too_pricy":
      case "not_using":
      case "another_solution":
      case "other":
        moveNextView("exclusive_offer")
        break
    }
  }

  return (
    <div className={styles.survey_container}>
      <h1 className="mb2--phone mb2--small-phone">Before you go</h1>

      <p className={styles.description}>Please select the reason you are canceling your subscription.</p>

      <div className={styles["options-container"]}>
        {Object.entries(options).map(([option, label]) => (
          <div key={option}>
            <div className={styles["radio-option"]} data-option={option} onClick={() => selectSurveryOption(option)}>
              <div className={`${styles["radio-circle"]} ${surveyOption === option ? styles.selected : ""}`} />
              <span className={styles["radio-label"]}>{label}</span>
            </div>
            {option === "other" && surveyOption === "other" && (
              <input
                name="other_reason"
                type="text"
                className={styles["other-input"]}
                placeholder="Tell us more"
                value={otherText}
                onChange={e => handleOtherTextChange(e.target?.value)}
              />
            )}
          </div>
        ))}
      </div>

      <div className="cancellation-actions cancellation-actions--survey">
        <button type="button" className="button-primary" onClick={onContinueClick} disabled={!surveyOption}>
          Continue
        </button>
      </div>
    </div>
  )
}

export default Survey
